import Vue from 'vue';
import PrettyInput from 'pretty-checkbox-vue/input';
import PrettyCheck from 'pretty-checkbox-vue/check';
import PrettyRadio from 'pretty-checkbox-vue/radio';
import vSelect from 'vue-select';
import PortalVue from 'portal-vue';

import BaseInput from './components/inputs/BaseInput';
import DataTable from './components/DataTable';
import CustomersTable from './components/tables/CustomersTable';
import CustomerAddressesTable from './components/tables/CustomerAddressesTable';
import ProductsTable from './components/tables/ProductsTable';
import OrdersTable from './components/tables/OrdersTable';
import AreasTable from './components/tables/AreasTable';
import UsersTable from './components/tables/UsersTable';
import DateInput from './components/inputs/DateInput';
import GlobalMixin from './mixins/global';
import CustomerInput from './components/inputs/CustomerInput';
import SelectInput from './components/inputs/SelectInput';
import ProductCategorySelectInput from './components/inputs/ProductCategorySelectInput';
import OrderForm from './components/orders/OrderForm';
import OrderRows from './components/orders/OrderRows';
import SearchBar from './components/SearchBar';
import Price from './components/Price';
import Icon from './components/Icon';

import config from './config';
import store from './store';

config.init();

Vue.use(PortalVue);
Vue.component('p-input', PrettyInput);
Vue.component('p-check', PrettyCheck);
Vue.component('p-radio', PrettyRadio);
Vue.component('Icon', Icon);
Vue.mixin(GlobalMixin);

new Vue({ // eslint-disable-line no-new
    el: '#app',
    components: {
        BaseInput,
        CustomerInput,
        DataTable,
        DateInput,
        Price,
        ProductCategorySelectInput,
        SearchBar,
        SelectInput,
        vSelect,

        // Tables
        CustomersTable,
        CustomerAddressesTable,
        ProductsTable,
        OrdersTable,
        AreasTable,
        UsersTable,

        // Orders
        OrderForm,
        OrderRows,
    },
    store,
});
